import React from 'react';
import { Input, Select } from 'antd';

import useDiscoverCategories from '../../hooks/useDiscoverCategories';
import { NO_TEXT_ASSIST } from '../../utils/fieldAssist';

/**
 * A listing's category, chosen from Discover's list (KPR-387). A category the
 * listing already carries that is no longer on the list is still shown (it is
 * not silently dropped); choosing another replaces it. Without a list (an
 * older server) it is the free-text box it used to be.
 */
export default function CategorySelect({ value, onChange, 'aria-label': ariaLabel = 'Category', allowClear = true, placeholder = 'Choose a category' }) {
	const categories = useDiscoverCategories();
	if (!categories.length) {
		return <Input {...NO_TEXT_ASSIST} value={value} maxLength={60} aria-label={ariaLabel} placeholder="Home, Business, Health…" onChange={event => onChange?.(event.target.value)} />;
	}
	const known = categories.some(c => c.toLowerCase() === String(value || '').trim().toLowerCase());
	const options = [
		...categories.map(c => ({ value: c, label: c })),
		...(value && !known ? [{ value, label: `${value} (not on the list)` }] : []),
	];
	// The list's spelling stands in for a differently-cased stored one.
	const shown = value ? (categories.find(c => c.toLowerCase() === String(value).trim().toLowerCase()) || value) : undefined;
	return (
		<Select
			value={shown}
			options={options}
			allowClear={allowClear}
			placeholder={placeholder}
			aria-label={ariaLabel}
			onChange={next => onChange?.(next || '')}
		/>
	);
}
